var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:"badge color-" + _vm.color,domProps:{"innerHTML":_vm._s(_vm.text)}})
}
var staticRenderFns = []

export { render, staticRenderFns }